import type { AxiosRequestConfig } from 'axios'
import apiClient from '../client'
import type { PageResponse } from '../types'
import type {
  ApplicationDocResponse,
  ApplicationDocCreateRequest,
  ApplicationDocUpdateRequest,
} from './types'

export const applicationDocsApi = {
  list(params?: {
    identId?: string
    applicantName?: string
    status?: string
    page?: number
    size?: number
  }) {
    return apiClient.get<PageResponse<ApplicationDocResponse>>('/api/application-documents', { params })
  },

  getById(id: number) {
    return apiClient.get<ApplicationDocResponse>(`/api/application-documents/${id}`)
  },

  getByIdentId(identId: string) {
    return apiClient.get<ApplicationDocResponse[]>(`/api/application-documents/by-ident/${identId}`)
  },

  uploadAttachment(id: number, key: string, file: File, config?: AxiosRequestConfig) {
    const formData = new FormData()
    formData.append('file', file)
    return apiClient.post<ApplicationDocResponse>(`/api/application-documents/${id}/attachments/${encodeURIComponent(key)}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 120_000,
      ...config,
    })
  },

  downloadAttachment(id: number, key: string, fileIndex?: number) {
    return apiClient.get(`/api/application-documents/${id}/attachments/${encodeURIComponent(key)}/download`, {
      params: fileIndex == null ? undefined : { fileIndex },
      responseType: 'blob',
    })
  },

  deleteAttachment(id: number, key: string, fileIndex?: number) {
    return apiClient.delete<ApplicationDocResponse>(`/api/application-documents/${id}/attachments/${encodeURIComponent(key)}`, {
      params: fileIndex == null ? undefined : { fileIndex },
    })
  },

  create(data: ApplicationDocCreateRequest) {
    return apiClient.post<ApplicationDocResponse>('/api/application-documents', data)
  },

  update(id: number, data: ApplicationDocUpdateRequest) {
    return apiClient.put<ApplicationDocResponse>(`/api/application-documents/${id}`, data)
  },

  submit(id: number) {
    return apiClient.post<ApplicationDocResponse>(`/api/application-documents/${id}/submit`)
  },

  approve(id: number, rebuildDetails = false) {
    return apiClient.post<ApplicationDocResponse>(
      `/api/application-documents/${id}/approve`,
      undefined,
      { params: { rebuildDetails } },
    )
  },

  reject(id: number, reason = '') {
    return apiClient.post<ApplicationDocResponse>(`/api/application-documents/${id}/reject`, { reason })
  },

  /** 不支給確定（差戻と並列の最終分岐。COMPLETED_DENIED へ遷移し、再提出不可） */
  deny(id: number) {
    return apiClient.post<ApplicationDocResponse>(`/api/application-documents/${id}/deny`)
  },

  delete(id: number) {
    return apiClient.delete<{ message: string }>(`/api/application-documents/${id}`)
  },
}
